/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment, useCallback } from 'react'
import InputBox from '../../components/InputBox'
import ErrorMessage from '../../components/ErrorMessage'
import TextArea from '../../components/TextArea'
import TopHeader from '../../components/TopHeader'
import { useState ,useContext,useEffect} from 'react'
import { useNavigate ,useParams,useLocation, useSearchParams} from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import GlobalContext from '../../components/Context/GloablContext'
import { Link } from 'react-router-dom'
import { validateEmail } from '../../CommonMethods/EmailValidator'
import CustomOverLay from '../../components/CustomOverLay'
import { motion } from 'framer-motion'
import AnimatedModel from '../../components/Animation/AnimatedModel'
import moment from 'moment'
import Loader from '../../components/Loader'
import ConfirmationPrompt from '../../components/ConfirmationPrompt'
import SearchEmptyScreen from '../../components/SearchEmptyScreen'
import { useAddMonitorUserMutation, useDeleteMonitorAssociatedOrganizationMutation, useDeletePatientAssociatedToMonitorMutation, useEditMonitorUserMutation, useGetMonitorOrganizationsQuery, useGetMonitorQuery, useLazyGetMonitorAssociatedOrganizationsQuery, useLazyGetMonitorSubdivisionsQuery, useLazyGetPatientAssociatedMonitorQuery, useLinkMonitortoOrganizationMutation,useLazyGetMonitorQuery } from '../../features/manageMonitorSlice'
// import EditPatients from './Components/editPatients'
import ProviderOrganizationAssocaition from '../ManageProvider/Components/ProviderOrganizationAssocaition'
import Debounce from '../../CommonMethods/Debounce'
import PhoneNumberValidator from '../../components/PhoneNumberInput'
import { phoneCodeArray } from '../../CommonMethods/phoneNumberCountryCodes'
import PatientAssociatedList from './Components/AssociatPatient'
import MonitorPatientList from './Components/PatientList'
import { useUpdateEmailMutation } from '../../features/apiSlice'
import { handleEditMessageSent,handleTargetUserEditId } from '../../redux/systemConfigSlice'
import { userService } from '../../services/user.services'
import { broadcastForcedLogout } from '../../CommonMethods/authSession'
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
 

export default function AddMonitorUser({edit}) {
    const [addManageMonitorUser] = useAddMonitorUserMutation()
    const [editMonitorUser]=useEditMonitorUserMutation()
    const location=useLocation()
    const [deleteLoading ,setdeleteLoading]=useState(false)
    const [limit, setLimit] = useState("15")
    const [isOpen, setisOpen] = useState(false);
    const [isOpensub, setisOpensub] = useState(false);
    const [associatedsuccess, setassociatedsuccess] = useState(false);
    const [isColumnSelect, setIsColumnSelect] = useState(false);
    const [deleteModel, setDeleteModel] = useState(false);
    const [selectedRowtoDelete, setSelectedRowtoDelete] = useState({});
    const [linkOrganizationModel, setLinkOrganizationModel] = useState(false);
    const [monitorUserId,setMonitorUserId] = useState('')
    const [payload, setpayload] = useState({});
    const [searchParams,setSearchParams] = useSearchParams()
    const [confirmationStateStatus,setConfirmationStateStatus]=useState(false)
    const [statusToggle,setStatusToggle]=useState(false)
    // Master switches (true = blocked, false = allowed). For new users default should be OFF (false).
    const [blockEmail, setBlockEmail] = useState(false)
    const [blockSms, setBlockSms] = useState(false)
    const [organizationListSearch, setOrganizationListSearch] = useState({search:''});
    const [selectedOrganizationName, setSelectedOrganizationName] = useState({
        organization_name: '',
        organization_id: '',
    });
    const [queryParamsOrg,setQueryParamsOrg] = useState('dropdown=true')
    const {id}=useParams()
    const [linkMonitor] = useLinkMonitortoOrganizationMutation()
    const isFromEdit = location.state?.[1] || false; 


    const [deleteAssociatedOrganization] = useDeleteMonitorAssociatedOrganizationMutation()

    const [selectedSubdivisionName, setSelectedSubdivisionName] = useState([]);

    const { data: organizationData, isFetching: organizationFetching } = useGetMonitorOrganizationsQuery(
        queryParamsOrg,  { refetchOnMountOrArgChange: true }
    );
   
    const [viewSearchParams, setViewSearchParams] = useState(`${id}?page_number=1&limit=15`);
  


    const [subTrigger, subresult, lastPromiseinfo1] = useLazyGetMonitorSubdivisionsQuery();
    const [triggermonitor,resultmonitor] = useLazyGetMonitorQuery()

   

    const [trigger, result,lastPromiseinfo] = useLazyGetMonitorAssociatedOrganizationsQuery();
    const [patientAssociatedTrigger,patientAssociatedResult]=useLazyGetPatientAssociatedMonitorQuery()
    const [emailButtonLoading,setEmailButtonLoading]=useState(false)
    const [emailVefiedButton,setEmailVeriedButton]=useState(true);
    const [updateEmail] = useUpdateEmailMutation()

    const [addMonitorUser,setAddMonitorUser]=useState({
        "user_name":"",
        "first_name":"",
        "last_name":"",
        "mobile_number":"",
        "main_number":"",
        "address":"",        
        "email_addr":"",
        "monitor_permission":true,
    })
    
    const [isDisableCancel,setIsdisableCancel] = useState(true)
    const userArr=useSelector(state=>state?.userSelect?.selectedUsers?.checkedArr)
    const [skip,setSkip]=useState(true)
    const {data,isFetching,status}=useGetMonitorQuery(id,{skip:skip})

    const [confirmationState,setConfirmationState]=useState(false)
    const [confirmationStateCancel,setConfirmationStateCancel]=useState(false)
    const { setToastmessage,setToastErrorMessage ,isSideBar,editSocket ,sendMessageToStartEditing,sendMessageToStopEditing} = useContext(GlobalContext)
    const [emptyField, setEmptyField] = useState(false)
    const [emailError,setEmailError]=useState({
        'text':false,
        "email_error":false,
        "username_error":false
    })
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({"mobile_number":true,"main_number":true});

    
    const [loading,setLoading]=useState(false)
    const navigate=useNavigate()
    const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables.date_format)
    const [countryCodeVal,setCountryCodeVal]=useState('')
    const [countryCodeVal2,setCountryCodeVal2]=useState('')
    const [emptyArea,setEmptyArea]=useState(false);
    const [usernameError,setUsernameError]=useState(false)
    const [loadingStatus,setLoadingStatus]=useState(false)
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [submitSelected,setSubmitSelected]=useState(false);
    const [showPatientList,setShowPatientList]=useState(false);
    const [orgDetails,setOrgDetails]=useState({});
    const [nextTarget, setNextTarget] = useState('');
    // for edit multiple user
    const messageSent=useSelector(state=>state?.systemConfigData?.messageSent)
    const [dataloading,setDataLoading] = useState(true)
    
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    const [queryParams,setQueryParams] = useState('?page_number=1&limit=15')
    const [pageItems,setPageItems]=useState('')
    
    const fetchPageAndLimitPat=()=>{
        const splitQuery = queryParams.split('?')[1];
        const params = new URLSearchParams(splitQuery); 
        return params
    }
    
    useEffect(() => {
        if (edit) {
            setQueryParamsadmin('type=admin-edit-monitor-users');
        } else {
            setQueryParamsadmin('type=admin-add-monitor-users');
        }
    }, [edit]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    const handleDeleteAssociatedOrganization = (item, index) => {
        
        setSelectedRowtoDelete(item)
        setDeleteModel(true)
    }

    const handleConfirmDelete = async () => {
        setdeleteLoading(true)
        let organization_id=selectedRowtoDelete.organization_id
        let subdivision_id=selectedRowtoDelete.subdivision_id
        const response = await deleteAssociatedOrganization({id,organization_id,subdivision_id})
        if (response?.error ) {
            setToastErrorMessage(response?.error?.data?.message)
            setDeleteModel(false)
            setdeleteLoading(false)
           
        } else{
            setToastmessage('Organization removed successfully')
            setDeleteModel(false)
            setdeleteLoading(false)
            setSelectedOrganizationName({
                organization_name: '',
                organization_id: '',
            })
            setSelectedSubdivisionName('')
            trigger(viewSearchParams)
        }
    
    }

    const handleCloseDeleteModal = () => {
        setDeleteModel(false)
    }

    const handleCloseLinkModel = () => {
        setLinkOrganizationModel(false)
    }

    useEffect(() => {
        trigger(viewSearchParams)
    }, [viewSearchParams])

    // const [queryParams,setQueryParams]=useState(`?page_number=1&limit=15&action=list`)
    const [totalPageNumber, setTotalPageNumber] = useState(1);
    // const {data,isFetching,isLoading,status}=useLazyGetAssociatedOrganizationsQuery(`${id}${queryParams}`)
    // const [exportSubdivision]=useExportSubdivisionMutation()
    const fetchPageAndLimit=()=>{
        const splitQuery = viewSearchParams.split('?')[1];
        const params = new URLSearchParams(splitQuery); 
        return params
    }

    const handlePrevClick = () => {
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) - 1);
    };
    
    const handleNextClick = () => {
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) + 1);
    };
    
    const [isOpenLimit, setIsOpenLimit] = useState(false);

    function handleNoOfRowsClick(number) {
        const params = fetchPageAndLimit()
        setViewSearchParams(`${viewSearchParams.split('?')[0]}?page_number=1&limit=${number}`);
    }

    const handleOnClickPageNumber = (pageNum) => {
        const params = fetchPageAndLimit()
        setViewSearchParams(`${viewSearchParams.split('?')[0]}?page_number=${pageNum}&limit=${params.get("limit")}`);
    };

    const calculateTotalPages = (totalRecords, limit) => {
        return Math.ceil(totalRecords / limit);
    };

    useEffect(() => {
        const calculatedTotalPages = calculateTotalPages(result?.data?.total_count, fetchPageAndLimit().get("limit"));
        setTotalPageNumber(calculatedTotalPages);
    }, [result.data]);

    const handleChangeOrg=(value)=>{
        if(value!==''){
            setQueryParamsOrg(`search=${encodeURIComponent(value)}&dropdown=true`)
        }else{
            setQueryParamsOrg('dropdown=true')
        }
    }

    const handleOrganizationSearchTrigger=useCallback(
        Debounce((value)=>handleChangeOrg(value,id)),[]
    )
    //  handle organization search
    const handleOrganizationListSearch = (value) => {
        setOrganizationListSearch({search:value})
        handleOrganizationSearchTrigger(value)
      
    };
  
    
    const handleChange=(val,id,user_id)=>{
        if(val.trim()!==''){
            subTrigger(`filter=true&organization_id=${id}&search=${encodeURIComponent(val)}&user_id=${user_id}`)

        }else{
            subTrigger(`filter=true&organization_id=${id}&user_id=${user_id}`)
        }
        
    }

    const handleSubdivisionSearchTrigger=useCallback(
        
        Debounce((value,id,user_id)=>handleChange(value,id,user_id)),
        []

    )
    // handle subdivision search
    const handleSubdivisionListSearch = (value,isApiCall) => {
        setSelectedOrganizationName((prevSearch) => {
            if (value !== '') {
                return {
                    ...prevSearch,
                    sub_division_name: value,
                };
            } else {
                // Remove the search key from the state if the value is empty
                const { sub_division_name, ...rest } = prevSearch;
                return rest;
            }
        });
        handleSubdivisionSearchTrigger(value,selectedOrganizationName.organization_id,monitorUserId)    
    }
    
    const handleFetchSubdivision = (item) => {
        setSelectedOrganizationName((prevState) => ({
            ...prevState,
            organization_name: item.organization_name,
            organization_id: item.organization_id,
        }));
        subTrigger(`filter=true&organization_id=${item?.organization_id}&user_id=${data.user_id}`)
        setisOpen(false);
        // this is use for refresh the subdivision value
        setSelectedSubdivisionName('')
    }

    const handleSelectionSubdivision = (item) => {
        setSelectedSubdivisionName((prevState) => {
            const isSelected = prevState?.some(subdiv => subdiv?.subdivision_id === item?.subdivision_id);
            if (isSelected) {
            // If the item is already selected, remove it
                return prevState?.filter(subdiv => subdiv?.subdivision_id !== item?.subdivision_id);
            } else {
            // If the item is not selected, add it
                return [...prevState, item];
            }
        });
        // setisOpensub(false);
    };

    const handleAddAssociation = async () => {
        setdeleteLoading(true)
        const subdivisionIds = selectedSubdivisionName.map(item => item.subdivision_id);
        let body = {
            "organization_id": selectedOrganizationName.organization_id,
            "subdivision_ids": subdivisionIds,
            
        }
        setisOpensub(false);
        const response = await linkMonitor({id,body})
        if(response?.data?.message === "Organization added successfully") {
            setToastmessage('Organization linked successfully')
            setassociatedsuccess(true);
            setSelectedOrganizationName({
                organization_name: '',
                organization_id: '',
            });
            setSelectedSubdivisionName('')
            setLinkOrganizationModel(false)
            trigger(viewSearchParams)
            setdeleteLoading(false)
        } else {
            setToastErrorMessage(response?.error?.data?.message);
            setassociatedsuccess(false);
            setisOpensub(false);
            setSelectedOrganizationName({});
            setSelectedSubdivisionName('')
            setLinkOrganizationModel(false)
            setdeleteLoading(false)
          
        }
    }

    const dispatch=useDispatch()
    
    function handleOnChangeUserDetails(id,option){
        setIsdisableCancel(false)
        setSubmitSelected(false)

        setEmptyField(false)
        setEmailError({
            text:false,
            email_error:false,
            username_error:false
        })
        const fieldToUpdate = {
            user_name:"user_name",
            first_name:"first_name",
            last_name:"last_name",
            mobile_number:"mobile_number",
            main_number:"main_number", 
            address:"address",        
            email_addr:'email_addr',
            admin_toggle:"admin_toggle",
            user_toggle:"user_toggle",    
            monitor_permission:"monitor_permission",      
        }[id];
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid=true

        if (id === "mobile_number"||id==="main_number") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid=false
            }
        }
        if(!isValid){
            if (fieldToUpdate) {
                setAddMonitorUser((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption
                }));
            }             
            return
        }
        if(fieldToUpdate){
            setIsdisableCancel(false)
            if(fieldToUpdate==="monitor_permission"){
                setAddMonitorUser((prev) => ({
                    ...prev,
                    [fieldToUpdate]: !option,
                }));
            }
            else if(fieldToUpdate==="mobile_number"||fieldToUpdate==="main_number"){
                // Validation: Can't delete mobile number when SMS is enabled
                if(fieldToUpdate==="mobile_number" && option.trim() === "" && !blockSms){
                    setToastErrorMessage("Monitor mobile number cannot be deleted while Master SMS Alert is enabled")
                    return
                }
                if(option.length<=20){
                    setAddMonitorUser((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if(fieldToUpdate==="first_name"||fieldToUpdate==="last_name"){
                if(option.length<=30){
                    setAddMonitorUser((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));

                }

            }
            else if(fieldToUpdate==="email_addr"||fieldToUpdate==="user_name"){
                setUsernameError(false)
                setEmailVeriedButton(true)
                setEmailButtonLoading(false)
                if(option.length<=80){
                    setAddMonitorUser((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option.replace(/\s/g, ''),
                    }));

                }
            }
            else{
                setAddMonitorUser((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }
            
        }

    }

    const handleOnAddManageMonitorUser=async()=>{
        setIsdisableCancel(false)
        setSubmitSelected(true)
        const hasEmptyFields = () => {
            let isFieldsEmpty=false
            if (
                addMonitorUser.user_name.trim() === "" ||
                addMonitorUser.first_name.trim() === "" ||
                addMonitorUser.last_name.trim() === "" ||
                addMonitorUser.main_number.trim() === ""||
                userArr[0].length===0 ||
                (edit ? addMonitorUser?.email_addr?.trim()==="" : "")
            // addMonitorUser.sub_division.trim() === ""
            ) {
                isFieldsEmpty = true;
            }
            return isFieldsEmpty;

        };
        if (hasEmptyFields()) {

            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");

            return;

        }
        if(validateEmail(addMonitorUser?.user_name?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "username_error":true,
                'text':true
            }))
           
            if(addMonitorUser?.email_addr?.trim()!==""&&validateEmail(addMonitorUser?.email_addr?.trim())) {  
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    'text':true
                }))
               
            }
            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return
        }
        if(addMonitorUser?.email_addr?.trim()!==""&&validateEmail(addMonitorUser?.email_addr?.trim())) {  

            setEmailError((prev)=>({
                ...prev,
                "email_error":true,
                'text':true
            }))
            setLoading(false);
            return
        }
        if(addMonitorUser?.email_addr?.trim()!==""&&validateEmail(addMonitorUser?.email_addr?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "email_error":true,
                'text':true
            }))
            return
        }
        if ((!(isPhoneNumberValid.main_number)&&addMonitorUser?.main_number!=='') || (!(isPhoneNumberValid.mobile_number)&&addMonitorUser?.mobile_number!=='')) {
            // Delay showing the toast message until isPhoneNumberValid is updated
            setLoading(false);
            return;
        }
        else{
            setConfirmationState(true)
        }

    }
   
    const handleFinalSubmit=async()=>{
        try {
            setLoading(true)
            let response = null
            let body = {
                "user_name":addMonitorUser.user_name.trim().replace(/\s/g, ''),
                "first_name": addMonitorUser.first_name.trim(),
                "last_name": addMonitorUser.last_name.trim(),
                // "email_address": edit ? undefined : addMonitorUser.user_name.trim().replace(/\s/g, ''),
                "mobile_number": addMonitorUser.mobile_number,
                "main_number": addMonitorUser.main_number,
                "mobile_country_code":"+"+(countryCodeVal2!==""?countryCodeVal2?.split('\t').join('')?.trim():country_code.split('\t').join('')?.trim()), 
                "main_country_code": "+"+(countryCodeVal!==""?countryCodeVal?.split('\t').join('')?.trim():country_code.split('\t').join('')?.trim()),
                "monitor_permission": addMonitorUser.monitor_permission === true ? "monitor" : "view",
                "address":addMonitorUser.address
            }
            // include master switches for both add + edit
            body["block_email"] = blockEmail
            body["block_sms"] = blockSms
            if (edit) {
                const editRes = await editMonitorUser({ id, body })
                //dispatch(handleIsAPICall(true))
                if (editRes?.error?.data?.message) {
                    const errorMessage = editRes?.error?.data?.message
                    // Handle validation errors and revert state if needed
                    if (errorMessage?.includes("Master SMS Alert cannot be enabled")) {
                        setBlockSms(true) // Revert to previous state
                    } else if (errorMessage?.includes("cannot be deleted while Master SMS")) {
                        // Revert mobile number change - handled in onChange
                    } else if (errorMessage?.includes("At least one monitor must have active alerts")) {
                        // Revert block states - would need to track previous values
                    }
                    setToastErrorMessage(errorMessage)
                    setLoading(false)
                }
                else {
                    // For edit, preserve the original state (no need to reset page number)
                    navigate(`/manage-monitor-user/${id}`, { state: location.state })
                    setToastmessage('Monitor user updated successfully');
                    setLoading(false)
                }
            }
            else {
          
                const addRes=await addManageMonitorUser(body)

         
                if(addRes?.error?.data?.message){
                    setConfirmationState(false)
                    setToastErrorMessage(addRes?.error?.data?.message)
                    setLoading(false)
                    if(addRes?.error?.data?.message==="Username already exists. Please try another"){
                        setUsernameError(true)
                    }
                }
                else{
                    // Update the state to set page_number to 1 while preserving other pagination settings
                    const updatedState = {
                        ...location.state,
                        page_number: '1'
                    };
                    console.log('Original state:', location.state);
                    console.log('Updated state with page_number=1:', updatedState);
                    navigate(`/manage-monitor-user/${addRes?.data?.user_id}`, { state: updatedState })
                    setToastmessage(addRes?.data?.message);
                    setLoading(false)
                }
            }
               
            
        } catch (error) {
            setLoading(false); 
            //dispatch(handleIsAPICall(true))
            setToastErrorMessage(error.message)   
        }
    }
    useEffect(()=>{
        if(edit){
            setSkip(false) 
        } 
        if(id){
            triggermonitor(id)      
        }       
    },[edit,id])

    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) {
                    return; // Prevent multiple logout calls
                }else if (event.data === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    broadcastForcedLogout();
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                    setTimeout(() => {
                        window.location.reload();
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    useEffect(()=>{
        if(resultmonitor!==undefined&&resultmonitor?.data?.user_id!==undefined){
            dispatch(handleTargetUserEditId(resultmonitor?.data?.user_id))
            if(edit&&!messageSent&&editSocket){
               
                sendMessageToStartEditing(resultmonitor?.data?.user_id)
            
                let message
                editSocket.onmessage = (event) =>{
                    message = event.data
                    if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                        setDataLoading(false)
                    } else{
                        dispatch(handleEditMessageSent(false))
                        navigate('/manage-monitor-user', { state: location.state })
                        { (JSON.parse(message)?.adminId) &&
                            setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this monitor`)
                        }
                    }
                }    
            }else{
                setDataLoading(false)
            }
            setMonitorUserId(resultmonitor?.data?.user_id)
            setAddMonitorUser((prev)=>({
                ...prev,
                "user_name":resultmonitor?.data?.user_name,
                "first_name":resultmonitor?.data?.first_name,
                "last_name":resultmonitor?.data?.last_name,
                "email_addr":resultmonitor?.data?.email_address,
                "mobile_number":resultmonitor?.data?.mobile_number,
                "main_number":resultmonitor?.data?.main_number,
                "address":resultmonitor?.data?.address,  
                'monitor_permission':resultmonitor?.data?.monitor_permission==='monitor' ? true : false,      

            }))
            setStatusToggle(resultmonitor?.data?.status==="inactive"?false:true)
            // Initialize block_email and block_sms from API response, default to false if not present
            const blockEmailValue = resultmonitor?.data?.block_email ?? resultmonitor?.data?.userDetails?.block_email
            const blockSmsValue = resultmonitor?.data?.block_sms ?? resultmonitor?.data?.userDetails?.block_sms
            setBlockEmail(blockEmailValue !== undefined ? blockEmailValue === true : false)
            setBlockSms(blockSmsValue !== undefined ? blockSmsValue === true : false)
            setSkip(true)
        }
        
        if(resultmonitor?.data&& edit){
            setCountryCodeVal(resultmonitor?.data?.main_country_code?.split('+')[1])
            setCountryCodeVal2(resultmonitor?.data?.mobile_country_code?.split('+')[1])
            patientAssociatedTrigger(`${resultmonitor?.data?.user_id}?page_number=1&limit=15`)

        }
        return(()=>{
          
            if(((location.state===null || location.state==='')&&resultmonitor?.data?.user_id!==undefined)){
                
                sendMessageToStopEditing(resultmonitor?.data?.user_id)
            }  
        })
    },[resultmonitor])
 
    
    const handleConformationClick = (status) => {
        setEmptyArea(false)
        status==="status"&&setStatusToggle(!statusToggle)
        setTextAreaMsg("")
        setConfirmationState(false);
        setConfirmationStateStatus(false);
    }
    const handleConformationClickCancel = () => {
        setEmptyArea(false)
        setConfirmationStateCancel(false);
    }

    const handleOnCLickActivate = async(e) => {
        // useDispatch(handleIsAPICall(true))
        if(statusToggle===false&& textAreaMsg.trim()===""){ 
            setToastErrorMessage('Please fill in the mandatory field')
        
            setEmptyArea(true)
            
            return;
        }
        try {
            let body = { }
            if(statusToggle===false){
                body={
                    "user_names": [data?.user_name],
                    "status":"inactive",
                    "note" : textAreaMsg 
                } 
            }
            else{
                body={
                    "user_names": [data?.user_name],
                    "status":"active",
                    "note":''
                } 
            }
            
            setLoadingStatus(true)
            
            const activationRes=await editMonitorUser({body})
            setLoadingStatus(false)
            
            if(activationRes?.data?.error){
                setToastErrorMessage(activationRes?.error?.data?.message)
            }else{
                setToastmessage(`Monitor user ${statusToggle===true?"activated":"deactivated"} successfully`);
                
            }
            setConfirmationStateStatus(false);
            setTextAreaMsg('');
           
        } catch (error) {
            setConfirmationStateStatus(false);
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }  

    const handleCancel = () => {
        setConfirmationStateCancel(false);
        // Clear form values
        setAddMonitorUser({
            "user_name": "",
            "first_name": "",
            "last_name": "",
            "mobile_number": "",
            "main_number": "",
            "address": "",
            "email_addr": "",
            "monitor_permission": true,
        });
        if (nextTarget === 'view') {
            navigate(`/manage-monitor-user/${id}`);
        } else {
            navigate('/manage-monitor-user', { state: location.state });
        }
    };
    
    const handleGobackFn = () => {
        setSearchParams({}); // Update the state with the modified URLSearchParams object as a string
    };

    const [isMonitorAddOrDelete, setIsMonitorAddOrDelete] = useState(false);
    const [deleteAssociatedPatient] = useDeletePatientAssociatedToMonitorMutation()

    const handleDeleteAssociatedPatient = (item, index) => {
        setSelectedRowtoDelete(item)
        setIsMonitorAddOrDelete(true)
        
    }

    const handleClosePatientDeleteModal = () => {
        setIsMonitorAddOrDelete(false)
    }
    
    const handleConfirmPatientDelete = async (type) => {
        setdeleteLoading(true);
        
        let patient_id = selectedRowtoDelete?.patient_id;
        let monitor_id = data?.user_id;
        
        let response = await deleteAssociatedPatient({ patient_id, monitor_id });
    
        if (response?.error) {
            setToastErrorMessage(response?.error?.data?.message);
            setIsMonitorAddOrDelete(false);
            setdeleteLoading(false);
        } else {
            setToastmessage(`Patient removed successfully`);
            setIsMonitorAddOrDelete(false);
            setdeleteLoading(false);
    
            // Get the current page and limit
            const params = fetchPageAndLimitPat();
            let currentPage = parseInt(params.get("page_number")) || 1;
            let limit = parseInt(params.get("limit")) || 15;
    
    
            // Only decrease the page number if the current page has only 1 item before deletion
            if (currentPage > 1 && parseInt(pageItems) === 1) {
                currentPage -= 1; // Move to the previous page
            }
    
            // Update query params and re-fetch data
            setQueryParams(`${monitor_id}?page_number=${currentPage}&limit=${limit}`);
            patientAssociatedTrigger(`${monitor_id}?page_number=${currentPage}&limit=${limit}`);
        }
    };
    
    
    const handleCloseBottom = () => {
        const stateToPass = Array.isArray(location.state) ? '' : location.state;

        if (isDisableCancel && (isFromEdit===true)) {
            navigate(`/manage-monitor-user/${id}`);
        } else if (isDisableCancel) {
            navigate('/manage-monitor-user',{state: stateToPass});
        } else {
            setNextTarget(
                (isFromEdit===true)
                    ? 'view'
                    : 'list'
            );
            setConfirmationStateCancel(true);
        }   
        // if (!isDisableCancel) {
        //     setConfirmationStateCancel(true);
        // } else {
        //     navigate('/manage-monitor-user');
        // }
    };
    const handleOnVerifyEmail=async()=>{           
        if(addMonitorUser?.email_addr?.trim()!==""&&validateEmail(addMonitorUser?.email_addr?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "email_error":true,
                'text':true
            }))

            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return
               
        }
        try {
            setEmailButtonLoading(true)
            let response = null
            let body={}
            body={
                "user_type":"monitor-user",
                "email_address": addMonitorUser.email_addr.trim().replace(/\s/g, ''),
            }
            const emailVerifyRes=await updateEmail({id,body})

            if(emailVerifyRes?.error?.data?.message==="Email Address must be a valid email address"){
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    'text':true
                })) 
                setEmailButtonLoading(false)
            }
            else if(emailVerifyRes?.error?.data?.message){
                setConfirmationState(false)
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    'text':false
                })) 
                setToastErrorMessage(emailVerifyRes?.error?.data?.message)
                setEmailButtonLoading(false)
            }
            else{
                setToastmessage(emailVerifyRes?.data?.message);
                setEmailButtonLoading(false)   
                setEmailVeriedButton(false)
            }
        } catch (error) {
            setLoading(false); 
            setToastErrorMessage(error.message)   
        }

    }

    useEffect(()=>{
        return(()=>{
       
            if(location?.state!==null||location?.state!==''){
         
                sendMessageToStopEditing()
            }
        })
       
    },[])
    

    const date=dateformat?.includes('AM/PM')?moment(data?.created_at+'Z')?.utcOffset('+05:30')?.format(`${dateformat.split(',')[0]} h:mm:ss A`):moment(data?.created_at).format(dateformat)
    return (
        <>
            
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Monitor User"}/>
                {((edit&& resultmonitor?.isFetching&& resultmonitor?.status!=="fulfilled"))?<CustomOverLay Active text= 'Loading Monitor User Details...' classKey={`absolute top-0 left-0 z-50 overflowhidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>
                    <div className='bg-white rounded-lg pb-[12px] pt-3.5 pl-6 pr-[10px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className='pr-6'>
                                    <div className='flex items-center mb-5'>
                                        <Link to="/manage-monitor-user" state={location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Monitor Users</h1>
                                        </Link>
                                        {isFromEdit===true &&<>
                                            <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>

                                            <Link to={`/manage-monitor-user/${location.state?.[2]}`}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Monitor User</h1>
                                            </Link>
                                        </>}
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">{edit ? "Edit" : "Add"} Monitor User</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                    
                                    </div>
                                    {searchParams.get('view')!==null?<>
                                        <div onClick={() =>handleGobackFn()} className='flex cursor-pointer items-center'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Edit Monitor</span>
                                        </div>
                                    </> : <>
                                        {isFromEdit===true ?
                                            <div onClick={handleCloseBottom}  className=' items-center cursor-pointer min-w-max flex'>
                                                <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                                <span className='text-sm font-normal text-[#008586] pl-3'>Go back to View Monitor User</span>
                                            </div> 
                                            :    
                                            <div onClick={handleCloseBottom} className='flex cursor-pointer items-center'>
                                                <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                                <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                            </div>
                                        }
                                        <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'>
                                            {`${edit?'Edit ':'Add '}Monitor User`}
                                        </h1>
                                        <p className='text-end pt-3.5 pb-1'>‘*’ Indicates mandatory field</p>
                                    </>}
                                    
                                </div>
                                {searchParams.get('view')!==null?<PatientAssociatedList 
                                    orgDetails={orgDetails}
                                    monitorId={data?.user_id}
                                />: <>
                                    <div className={`pr-5 h-customh15 overflow-auto overflow-x-hidden scrollbar_purple bg-white`}>
                                        <div className="border border-[#C5C9DA] rounded-lg px-6 2xl:px-[57px] py-6 mb-4">
                                            <div className='flex flex-wrap -mx-3'>
                                                {edit&&<div className={`w-1/3 px-3 mb-[22px]`}>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Username*"} 
                                                            placeholder={"Enter username"}
                                                            id={"user_name"}
                                                            htmlFor={"Admin_Username"}
                                                            value={addMonitorUser.user_name}
                                                            emailError={emailError.username_error}
                                                            usernameError={usernameError}
                                                            emptyField={emptyField&&addMonitorUser?.user_name?.trim()===""}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                            disabled={true}
                                                        />
                                                        {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '}  message={"Invalid user name"}/>}
                                                    </div>
                                                </div>}
                                                {!edit&&<div className={`w-1/3 px-3 mb-[22px]`}>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Username*"} 
                                                            placeholder={"Enter username"}
                                                            id={"user_name"}
                                                            htmlFor={"Admin_Username"}
                                                            value={addMonitorUser.user_name}
                                                            emailError={emailError.username_error}
                                                            usernameError={usernameError}
                                                            emptyField={emptyField&&addMonitorUser?.user_name?.trim()===""}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                            
                                                        />
                                                        {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '}  message={"Invalid user name"}/>}
                                                    </div>
                                                </div>}
                                                <div className='w-1/3 px-3 mb-[22px]'>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"First Name*"} 
                                                            placeholder={"Enter first name"}
                                                            id={"first_name"}
                                                            htmlFor={"Admin_First_Name"}
                                                            value={addMonitorUser.first_name}
                                                            emptyField={emptyField&&addMonitorUser?.first_name?.trim()===""}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-1/3 px-3 mb-[22px]'>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Last Name*"} 
                                                            placeholder={"Enter last name"}
                                                            id={"last_name"}
                                                            htmlFor={"Admin_Last_Name"}
                                                            value={addMonitorUser.last_name}
                                                            emptyField={emptyField&&addMonitorUser?.last_name?.trim()===""}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                    </div>
                                                </div>
                                                {!edit && 
                                                    <div className={`w-1/3 px-3 mb-[22px]`}>
                                                        <div className='w-full'>
                                                            <InputBox
                                                                label={"Email Address*"} 
                                                                placeholder={"Enter email address"}
                                                                id={"email_addr"}
                                                                htmlFor={"email_addr"}
                                                                value={addMonitorUser.user_name}
                                                                emptyField={false}
                                                                disabled={true}
                                                                emailError={emailError.email_error}
                                                                handleOnChangeInput={handleOnChangeUserDetails}
                                                            />
                                                            {emailError.email_error && <ErrorMessage error  message={"Invalid email address"}/>}
                                                        </div>
                                                    </div>
                                                }
                                                
                                                <div className='w-1/3 px-3 mb-[22px]'>
                                                    <div className='w-full'>

                                                        <PhoneNumberValidator
                                                            label={"Mobile Number"}
                                                            placeholder={"Enter Mobile Number"}
                                                            id={"mobile_number"}
                                                            htmlFor={"Admin_Mobile_Number"}
                                                            value={addMonitorUser.mobile_number}
                                                            emptyField={false}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                            isCode={true}
                                                            countryCodeList={phoneCodeArray}
                                                            country_code={country_code}
                                                            countryCodeVal={countryCodeVal2}
                                                            isPhoneNumberValid={isPhoneNumberValid?.mobile_number}
                                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                            setCountryCodeVal={setCountryCodeVal2}
                                                            submitSelected={submitSelected}
                                                        //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-1/3 px-3 mb-[22px]'>
                                                    <div className='w-full'>
                                                        <PhoneNumberValidator
                                                            label={"Main Number*"} 
                                                            placeholder={"Enter Main Number"}
                                                            id={"main_number"}
                                                            htmlFor={"Admin_Mobile_Number"}
                                                            value={addMonitorUser.main_number}
                                                            emptyField={emptyField&&addMonitorUser?.main_number?.trim()===""}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                            isCode={true}
                                                            countryCodeList={phoneCodeArray}
                                                            country_code={country_code}
                                                            countryCodeVal={countryCodeVal}
                                                            setCountryCodeVal={setCountryCodeVal}
                                                            isPhoneNumberValid={isPhoneNumberValid?.main_number}
                                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                            submitSelected={submitSelected}
                                                            //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}

                                                        />
                                                    </div>
                                                </div>
                                                {edit && <>
                                                    <div className={`w-1/3 px-3 mb-[22px]`}><div className='w-full'></div></div>
                                                    <div className={`w-1/3 px-3 mb-[22px]`}>
                                                        <div className='w-full'>
                                                            <InputBox
                                                                label={"Email Address*"} 
                                                                placeholder={"Enter email address"}
                                                                id={"email_addr"}
                                                                htmlFor={"email_addr"}
                                                                value={addMonitorUser.email_addr}
                                                                emptyField={emptyField&&addMonitorUser?.email_addr?.trim()===""}
                                                                emailError={emailError.email_error}
                                                                handleOnChangeInput={handleOnChangeUserDetails}
                                                            />
                                                            {emailError.email_error && <ErrorMessage error  message={emailError?.text&&"Invalid email address"}/>}
                                                        </div>
                                                    </div>
                                                    {( (resultmonitor?.data?.email_address !== addMonitorUser?.email_addr)) && 
                                                        <div className={`flex items-start gap-12 w-2/3 px-[30px] mb-[35px] pt-3.5`}>
                                                            <button type='button'
                                                                id="verify"
                                                                onClick={() => handleOnVerifyEmail()}
                                                                disabled={emailButtonLoading || !emailVefiedButton || addMonitorUser?.email_addr?.trim()===""}
                                                                className={`px-4 py-2 text-lg flex items-center justify-center font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[170px]
                                                        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                                                {!emailButtonLoading ? "Verify" : <span>{<Loader />}</span>}
                                                            </button>
                                                            <div className='flex-1'>
                                                                <p className='text-sm font-semibold text-[#000000] mb-3'>Block Active Alerts</p>
                                                                <div className='flex flex-row gap-4'>
                                                                    <div className="status custom-toggle flex items-center">
                                                                        <label className="switch" style={{marginLeft: '0px'}}>
                                                                            <input
                                                                                type="checkbox"
                                                                                onChange={() => {
                                                                                    const nextValue = !blockSms
                                                                                    // Validation: can't allow SMS alerts (unblock) without a mobile number
                                                                                    if (nextValue === false && (!addMonitorUser.mobile_number || addMonitorUser.mobile_number.trim() === "")) {
                                                                                        setToastErrorMessage("Master SMS Alert cannot be enabled without a mobile number")
                                                                                        return
                                                                                    }
                                                                                    setBlockSms(nextValue)
                                                                                    setIsdisableCancel(false)
                                                                                }}
                                                                                checked={blockSms}
                                                                            />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                        <p className="text-sm font-normal text-[#008586] disable_switch ml-3">
                                                                            SMS
                                                                        </p>
                                                                    </div>
                                                                    <div className="status custom-toggle flex items-center">
                                                                        <label className="switch" style={{marginLeft: '0px'}}>
                                                                            <input 
                                                                                type="checkbox" 
                                                                                onChange={(e) => {
                                                                                    setBlockEmail(!blockEmail)
                                                                                    setIsdisableCancel(false)
                                                                                }} 
                                                                                checked={blockEmail}
                                                                            />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                        <p className="text-sm font-normal text-[#008586] disable_switch ml-3">
                                                                            Email
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }                
                                                    {((resultmonitor?.data?.email_address === addMonitorUser?.email_addr)) && 
                                                        <div className={`flex items-start gap-12 w-2/3 px-[18px] mb-[35px] pt-3`}>
                                                            <button type='button'
                                                                id="verified"
                                                                className={`px-4 py-2 flex items-center justify-center text-lg font-semibold text-[#000] rounded-[16px] mt-2.5 w-[170px] cursor-default
                                                                            bg-[#C5C9DA] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                                                <span className='w-6 h-6 bg-[#1A883C] rounded-[50%] mr-2.5 flex justify-center items-center'>
                                                                    <img src="/images/success_toast.svg" alt="icon" loading='lazy'  className='w-3.5 h-3.5' decoding='async' />
                                                                </span>
                                                                Verified
                                                            </button>
                                                            <div className='flex-1'>
                                                                <p className='text-sm font-semibold text-[#000000] mb-3'>Block Active Alerts</p>
                                                                <div className='flex flex-row gap-4'>
                                                                    <div className="status custom-toggle flex items-center">
                                                                        <label className="switch" style={{marginLeft: '0px'}}>
                                                                            <input
                                                                                type="checkbox"
                                                                                onChange={() => {
                                                                                    const nextValue = !blockSms
                                                                                    // Validation: can't allow SMS alerts (unblock) without a mobile number
                                                                                    if (nextValue === false && (!addMonitorUser.mobile_number || addMonitorUser.mobile_number.trim() === "")) {
                                                                                        setToastErrorMessage("Master SMS Alert cannot be enabled without a mobile number")
                                                                                        return
                                                                                    }
                                                                                    setBlockSms(nextValue)
                                                                                    setIsdisableCancel(false)
                                                                                }}
                                                                                checked={blockSms}
                                                                            />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                        <p className="text-sm font-normal text-[#008586] disable_switch ml-3">
                                                                            SMS
                                                                        </p>
                                                                    </div>
                                                                    <div className="status custom-toggle flex items-center">
                                                                        <label className="switch" style={{marginLeft: '0px'}}>
                                                                            <input 
                                                                                type="checkbox" 
                                                                                onChange={(e) => {
                                                                                    setBlockEmail(!blockEmail)
                                                                                    setIsdisableCancel(false)
                                                                                }} 
                                                                                checked={blockEmail}
                                                                            />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                        <p className="text-sm font-normal text-[#008586] disable_switch ml-3">
                                                                            Email
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>}
                                                <div className={`w-1/3 px-3 mb-[22px]`}>
                                                    <div className='w-full'>
                                                        <p className='text-sm font-semibold text-[#000000] mb-1.5'>Monitor Permission</p>
                                                        <div className='flex items-center'>
                                                            <div className="p-2">
                                                                <div className="relative custom-radioBlue flex items-center">
                                                                    <input id="moniter_true" type="radio" name="default-radio1" checked={addMonitorUser?.monitor_permission} onChange={()=>handleOnChangeUserDetails("monitor_permission",false)}/>
                                                                    <label htmlFor="moniter_true" className={`text-base font-normal ${addMonitorUser?.monitor_permission ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                                        Monitor
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="p-2">
                                                                <div className="relative custom-radioBlue flex items-center" >
                                                                    <input id="view_true"  type="radio" name="default-radio1" checked={!addMonitorUser?.monitor_permission} onChange={()=>handleOnChangeUserDetails("monitor_permission",true)}/>
                                                                    <label htmlFor="view_true" className={`text-base font-normal ${!addMonitorUser?.monitor_permission ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                                        View 
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Add mode: show Block Active Alerts (OFF by default) to the right of Monitor Permission */}
                                                {!edit && (
                                                    <div className='w-1/3 pl-0 pr-3 mb-[22px] ml-[13px]'>
                                                        <div className='w-full pt-2'>
                                                            <p className='text-sm font-semibold text-[#000000] mb-3'>Block Active Alerts</p>
                                                            <div className='flex flex-row gap-4'>
                                                                <div className="status custom-toggle flex items-center">
                                                                    <label className="switch" style={{marginLeft: '0px'}}>
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={() => {
                                                                                const nextValue = !blockSms
                                                                                // Validation: can't allow SMS alerts (unblock) without a mobile number
                                                                                if (nextValue === false && (!addMonitorUser.mobile_number || addMonitorUser.mobile_number.trim() === "")) {
                                                                                    setToastErrorMessage("Master SMS Alert cannot be enabled without a mobile number")
                                                                                    return
                                                                                }
                                                                                setBlockSms(nextValue)
                                                                                setIsdisableCancel(false)
                                                                            }}
                                                                            checked={blockSms}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                    <p className="text-sm font-normal text-[#008586] disable_switch ml-3">SMS</p>
                                                                </div>
                                                                <div className="status custom-toggle flex items-center">
                                                                    <label className="switch" style={{marginLeft: '0px'}}>
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={() => {
                                                                                setBlockEmail(!blockEmail)
                                                                                setIsdisableCancel(false)
                                                                            }}
                                                                            checked={blockEmail}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                    <p className="text-sm font-normal text-[#008586] disable_switch ml-3">Email</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {edit&&<div className='w-1/3 px-[18px] mb-[22px]'>
                                                    <div className='w-full mt-10 '>
                                                        <div className="status custom-toggle flex items-center ">
                                                            <p className="text-sm font-normal  text-[#000000] disable_switch  mr-4">
                                                                Status
                                                            </p> 
                                                            <label className="switch" style={{marginLeft: '10px'}}>
                                                                <input type="checkbox" id="user_status" onChange={(e)=>{
                                                                    setStatusToggle(!statusToggle),setConfirmationStateStatus(true)
                                                                }} checked={statusToggle} /><span className="slider round"></span>
                                                            </label>
                                                            <p className="text-sm font-normal  text-[#008586] disable_switch ml-3" id="status">
                                                                {statusToggle?'Active':'Inactive'}
                                                            </p> 
                                                        </div>
                                                    </div>
                                                </div> }
                                                <div className={`${edit?'w-full':'w-2/3'} px-3`}>
                                                    <div className={`w-full mb-6 ${edit?'h-[100px]':'h-[120px]'}`}>
                                                        <TextArea label={'Address'}
                                                            htmlFor={'user_address'}
                                                            id={'address'}
                                                            value={addMonitorUser?.address}
                                                            placeholder={'Enter Address'}
                                                            // emptyField={false}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <EditPatients/> */}
                                            {edit&&
                                                <>
                                                    <MonitorPatientList 
                                                        user_id={data?.user_id}
                                                        providerData={data}
                                                        patientAssociatedTrigger={patientAssociatedTrigger}
                                                        data={patientAssociatedResult?.data}
                                                        isFetching={patientAssociatedResult?.isFetching}
                                                        status={patientAssociatedResult?.status} 
                                                        handleDeleteAssociatedPatient={handleDeleteAssociatedPatient}
                                                        fetchPageAndLimit={fetchPageAndLimitPat}
                                                        queryParams={queryParams}
                                                        setQueryParams={setQueryParams}
                                                        pageItems={pageItems}
                                                        setPageItems={setPageItems}
                                                    />
                                                
                                                    <ProviderOrganizationAssocaition
                                                        organizationData={organizationData}
                                                        organizationFetching={organizationFetching}
                                                        handleOrganizationListSearch={handleOrganizationListSearch}
                                                        organizationListSearch={organizationListSearch}
                                                        handleFetchSubdivision={handleFetchSubdivision}
                                                        subdivisionData={subresult?.data}
                                                        handleSubdivisionListSearch={handleSubdivisionListSearch}
                                                        selectedOrganizationName={selectedOrganizationName}
                                                        handleAddAssociation={handleAddAssociation}
                                                        associatedOrganizations={result?.data}
                                                        selectedSubdivisionName={selectedSubdivisionName}
                                                        isOpen={isOpen}
                                                        setisOpen={setisOpen}
                                                        setisOpensub={setisOpensub}
                                                        isOpensub={isOpensub}
                                                        limit={limit}
                                                        setLimit={setLimit}
                                                        handleNoOfRowsClick={handleNoOfRowsClick}
                                                        handleOnClickPageNumber={handleOnClickPageNumber}
                                                        isColumnSelect={isColumnSelect}
                                                        setIsColumnSelect={setIsColumnSelect}
                                                        isOpenLimit={isOpenLimit}
                                                        setSelectedSubdivisionName={setSelectedSubdivisionName}
                                                        setIsOpenLimit={setIsOpenLimit}
                                                        handlePrevClick={handlePrevClick}
                                                        handleNextClick={handleNextClick}
                                                        fetchPageAndLimit={fetchPageAndLimit}
                                                        totalPageNumber={totalPageNumber}
                                                        result={result}
                                                        isSideBar={isSideBar}
                                                        handleDeleteAssociatedOrganization={handleDeleteAssociatedOrganization}
                                                        setLinkOrganizationModel={setLinkOrganizationModel}
                                                        handleSelectionSubdivision={handleSelectionSubdivision}
                                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                                        subdivisionloadingstatus={subresult}
                                                        isMonitor={true}
                                                        showPatientList={showPatientList}
                                                        setShowPatientList={setShowPatientList}
                                                        setOrgDetails={setOrgDetails}
                                                    />
                                                </>}
                                        </div>
                                    </div> 
                                    <div className='flex justify-end pr-5'>
                                        <button
                                            type="button"
                                            id="cancel"
                                            onClick={handleCloseBottom}
                                        
                                            className={`px-4 py-2.5 text-lg font-semibold text-[#972E4C] rounded-[16px] mt-2.5 w-[148px]
            border border-[#972E4C] `}
                                            
                                        >
                                            Cancel
                                        </button>
                                        <button type='button'
                                            id="update"
                                            onClick={handleOnAddManageMonitorUser}
                                            className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px] ml-4
                                    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                            {edit?'Update':'Submit'}
                                        </button>
                                    </div>
                                </>}
                            </div>
                        </motion.div>
                    </div>
                </>}
                {confirmationState && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={""}
                                handleOnCLickActivate={handleFinalSubmit}
                                handleClose={handleConformationClick}
                                tittle= {`${edit?'Update':'Add Monitor User'}`}
                                message = {`Are you sure you want to ${edit?'update':'add'}  this monitor user?`}
                                textMessage = {true===false?false:true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}                                
                                CancelButton={'No'}
                                disabled={loading}
                            />
                        }
                    /> 
                }
                {confirmationStateCancel && 
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleCancel}
                                handleClose={handleConformationClickCancel}
                                tittle={'Cancel'}
                                message={`Are you sure you want to cancel the changes?`}
                                textMessage = {true===false?false:true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}                                
                                CancelButton={'No'}
                            />
                        }
                    /> 
                }
                {deleteModel &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleConfirmDelete}
                            handleClose={handleCloseDeleteModal}
                            tittle={'Remove'}
                            message={`Are you sure you want to remove the organization?`}
                            buttonName={"Confirm"}
                            loadingActivation={deleteLoading}
                            // CancelButton={"No"}
                            disabled={deleteLoading}
                        />
                    }
                />}
                {linkOrganizationModel &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={handleAddAssociation}
                                handleClose={handleCloseLinkModel}
                                tittle={'Link Organization'}
                                message={`Are you sure you want to link the organization and sub division?`}
                                buttonName={"Yes"}
                                loadingActivation={deleteLoading}
                                CancelButton={"No"}
                                disabled={deleteLoading}
                            />
                        }
                    />}
                {confirmationStateStatus && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                disabled={loadingStatus}
                                loadingActivation={loadingStatus}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={()=>{handleConformationClick("status")}}
                                tittle= {statusToggle?'Activate':'Deactivate'}
                                message = {`Are you sure you want to ${statusToggle? 'activate' : 'deactivate'} this Monitor user?`}
                                textMessage = {statusToggle===false?false:true}
                                buttonName = {statusToggle?'Activate':'Deactivate'}
                            />
                        }
                    /> 
                }
                {isMonitorAddOrDelete &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleConfirmPatientDelete}
                            handleClose={handleClosePatientDeleteModal}
                            tittle={'Remove'}
                            message={`Are you sure you want to remove the patient?`}
                            buttonName={"Confirm"}
                            loadingActivation={deleteLoading}
                            // CancelButton={"No"}
                            disabled={deleteLoading}
                        />
                    }
                />}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                }

               

            </div>
        </>
    )}
